<div class="preview-container">
  <div class="close-btn-topright" (click)="close()">
    <img src="assets/images/close.svg" alt="Close" />
  </div>

  <!-- Image -->
  <div class="preview-image">
    <img
      [src]="template?.images?.[0] || 'https://upload.wikimedia.org/wikipedia/commons/a/a3/Image-not-found.png?20210521171500'"
      alt="template-image" />
  </div>

  <!-- Custom Tabs -->
  <div class="custom-tabs">
    <button [class.active]="selectedTabIndex === 0" (click)="selectedTabIndex = 0">Overview</button>
    <button [class.active]="selectedTabIndex === 1" (click)="selectedTabIndex = 1">Template</button>
    <button [class.active]="selectedTabIndex === 2" (click)="selectedTabIndex = 2">Framework</button>
  </div>

  <!-- Overview -->
  <div class="tab-content" *ngIf="selectedTabIndex === 0">

    <div class="two-col-grid">
      <!-- LEFT COLUMN -->
      <div class="left-col">
        <div class="detail-section">
          <div class="font16  mb-1">Description</div>
          <div class="font14">{{ template?.description || 'No description provided' }}</div>
        </div>

        <div class="detail-section">
          <div class="font161 mb-1">Specifications</div>
          <div class="font141">{{ template?.specifications || 'Not specified' }}</div>
        </div>

        <div class="detail-section" *ngIf="template?.bestChannels?.length">
          <div class="font162 mb-1">Best Channels</div>
          <div class="chip-container">
            <span class="custom-chip" *ngFor="let channel of template?.bestChannels">
              {{ channel }}
            </span>
          </div>
        </div>

        <div class="detail-section" *ngIf="template?.tags?.length">
          <div class="font163 mb-1">Tags</div>
          <div class="chip-container">
            <span class="custom-chip" *ngFor="let tag of template?.tags">#{{ tag }}</span>
          </div>
        </div>
      </div>

      <!-- RIGHT COLUMN -->
      <div class="right-col">
        <div class="detail-section">
          <div class="font164 mb-1">Call to Action</div>
          <div  class="hover-secondary">
            {{ template?.callToAction || 'No CTA' }}
          </div>
        </div>

        <div class="detail-section" *ngIf="template?.goals?.length">
          <div class="font165 mb-1">Goals</div>
          <div class="chip-container">
            <span class="custom-chip" *ngFor="let goals of template?.goals">
              {{ goals.name }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Template -->
  <div class="tab-content" *ngIf="selectedTabIndex === 1">
    <div class="font166 mb-1">Fill in the Blanks</div>
    <pre class="template-box">{{ template?.templateText || 'No template provided' }}</pre>
  </div>

  <!-- Framework -->
  <div class="tab-content" *ngIf="selectedTabIndex === 2">
  
    <div class="detail-section" >
      <div class="font167 mb-1">Hook Strategy</div>
      <pre class="template-box1">{{ template?.hookStrategy || 'No strategy provided' }}</pre>
    </div>

    <div class="detail-section">
      <div class="font168 mb-1">Content Structure</div>
      <pre class="template-box">{{ template?.contentStructure || 'No content structure provided' }}</pre>
    </div>
    <div class="detail-section" *ngIf="template?.callToAction">
    <div class="font164 mb-1">Call to Action</div>
    <div class="hover-secondary">
      {{ template?.callToAction }}
    </div>
  </div>
  </div>
  

  <!-- Footer -->
  <div class="footer-buttons">
    <div class="custom-purple-button" (click)="useTemplate()">Edit</div>
    <div class="status d-flex align-items-center" [ngClass]="{'pending': data?.template?.templateStatus === 'PENDING', 'approved': data?.template?.templateStatus === 'APPROVED', 'rejected': data?.template?.templateStatus === 'REJECTED'}">{{data?.template?.templateStatus | titlecase}}</div>
    <div class="approval d-flex justify-content-end gap-2" *ngIf="this?.data?.template?.templateStatus === 'PENDING' && isAdmin">
      <div class="reject common_btn cursor-pointer" data-bs-toggle="modal" data-bs-target="#exampleModalCenter1"> <img
          class="icon_img" src="https://d2yx15pncgmu63.cloudfront.net/prod-images/771972c1748504087973Vector (2).png"
          alt="">
        Reject</div>
      <div class="approve common_btn cursor-pointer" data-bs-toggle="modal" data-bs-target="#exampleModalCenter"> <img
          class="icon_img" src="https://d2yx15pncgmu63.cloudfront.net/prod-images/723966c1748504211081Icon left.png"
          alt="">
        Approve</div>
      <div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-bs-backdrop="false">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content custom-content">
            <div class="header">
              <div class="modal-title" id="exampleModalLongTitle">Approve Template</div>
            </div>
            <div class="modal-body">
              Are you sure you want to approve this template? Once approved template will be live
            </div>
            <div class="footer">
              <button type="button" class="approve-btn" (click)="updateTemplateStatus('APPROVED')">Approve
                Template</button>
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">Cancel</button>
            </div>
          </div>
        </div>
      </div>
      <div class="modal fade" id="exampleModalCenter1" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalCenterTitle" aria-hidden="true" data-bs-backdrop="false">
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content custom-content">
            <div class="header">
              <div class="modal-title" id="exampleModalLongTitle">Reject Template</div>
            </div>
            <div class="modal-body">
              Are you sure you want to reject this template?
            </div>
            <div class="footer">
              <button type="button" class="reject-btn" (click)="updateTemplateStatus('REJECTED')">Reject Template</button>
              <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" aria-label="Close">Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
